
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from './components/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeroSection from './components/HeroSlider';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import ContactUs from './pages/ContactUs';
import Enquiry from './pages/Enquiry';
import Packages from './pages/Packages';
import Gallery from './pages/Gallery';
import CareerSection from './pages/CareerSection';
import Booking from './pages/Booking';
import Service from './pages/Service';
import OurNetwork from './pages/OurNetwork.js';
import Punetooutstationcabservice from './pages/Pune Outstation Cab Service.js';
import ScrollToTop from './components/ScrollToTop.js';
import Punetaxiservice from './pages/Pune Taxi Service.js';
import Punecabbooking from './pages/Pune Cab Booking.js';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune.js';
import Outstationtaxiservicepune from './pages/Outstation Taxi Service Pune.js';
import Cheapcabinpune from './pages/Cheap Cabs in Pune.js';
import Punecabfare from './pages/Pune Cab Fare.js';
import Corporatecabservicepune from './pages/Corporate Cab Service Pune.js';
import Puneairportcab from './pages/Pune Airport Cab.js';
import Punerailwaystationcabservice from './pages/Pune Railway Station Cab Service.js';
import Puneonewaycabservice from './pages/Pune One Way Cab Service.js';
import Punelocalandouutstationcab from './pages/Pune Local and Outstation Cab.js';
import Punetomumbaicab from './pages/Pune to Mumbai Cab.js';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab.js';
import Punetonashikcabservice from './pages/Pune to Nashik Cab Service.js';
import Punetonagpurcab from './pages/Pune to Nagpur Cab.js';
import Punetokolhapurcab from './pages/Pune to Kolhapur Cab.js';
import Punetosolapurcabservice from './pages/Pune to Solapur Cab Service.js';
import Punetoahmednagartaxi from './pages/Pune to Ahmednagar Taxi.js';
import Punetosanglicab from './pages/Pune to Sangli Cab.js';
import Punetosataracabservice from './pages/Pune to Satara Cab Service.js';
import Punetojalgaoncabservice from './pages/Pune to Jalgaon Cab Service.js';
import Punetothanecab from './pages/Pune to Thane Cab.js';
import Punetopanvelcab from './pages/Pune to Panvel Cab.js';
import Punetohyderabadcab from './pages/Pune to Hyderabad Cab.js';
import Punetogoacabservice from './pages/Pune to Goa Cab Service.js';
import Punetosambhajinagar from './pages/Pune to Sambhaji Nagar Cab.js';
import Punetonandedcabservice from './pages/Pune to Nanded Cab Service.js';
import Punetoindorecab from './pages/Pune to Indore Cab.js';
import Punetosuratcab from './pages/Pune to Surat Cab.js';
import Punetoujjaincabservice from './pages/Pune to Ujjain Cab Service.js';
import Punetolonavalacab from './pages/Pune to Lonavala Cab.js';
import Punetomatherantaxiservice from './pages/Pune to Matheran Taxi Service.js';
import Punetomahabaleshwartaxi from './pages/Pune to Mahabaleshwar Taxi.js';
import Punetopanchganicab from './pages/Pune to Panchgani Cab Service.js';
import Punetolgatpuritaxi from './pages/Pune to Igatpuri Taxi.js';
import Punetobhandardaracab from './pages/Pune to Bhandardara Cab.js';
import Punetokarjatcab from './pages/Pune to Karjat Cab.js';
import Punetoambolighattaxi from './pages/Pune to Amboli Ghat Taxi.js';
import Punetochikhaldara from './pages/Pune to Chikhaldara Cab.js';
import Punetotamhinighatcab from './pages/Pune to Tamhini Ghat Cab.js';
import Punetoshirdicab from './pages/Pune to Shirdi Cab.js';
import Punetotrimkeshwarcabservice from './pages/Pune to Trimbakeshwar Cab Service.js';
import Punetobhimashankartaxiservice from './pages/Pune to Bhimashankar Taxi Service.js';
import Punetoashtavinayakdarshancab from './pages/Pune to Ashtavinayak Darshan Cab.js';
import Punetojejuricab from './pages/Pune to Jejuri Cab Service.js';
import Punetopandharpurtaxi from './pages/Pune to Pandharpur Taxi.js';
import Punetotuljapurcab from './pages/Pune to Tuljapur Cab.js';
import Punetoakkalkotcabservice from './pages/Pune to Akkalkot Cab Service.js';
import Punetoshanishingnapurcab from './pages/Pune to Shani Shingnapur Cab.js';
import Punetoshegaoncab from './pages/Pune to Shegaon Cab.js';
import Punetoganpatipuletaxi from './pages/Pune to Ganpatipule Taxi.js';
import Punetokonkandarshancab from './pages/Pune to Konkan Darshan Cab.js';
import Punetoalibaugcab from './pages/Pune to Alibag Cab.js';
import Punetoratnagiritaxiservice from './pages/Pune to Ratnagiri Taxi Service.js';
import Punetotarkalicab from './pages/Pune to Tarkarli Cab.js';
import Punetosindhudurgcabseervice from './pages/Pune to Sindhudurg Cab Service.js';
import Punetoharihareshwartaxi from './pages/Pune to Harihareshwar Taxi.js';
import Punetodivegarcab from './pages/Pune to Diveagar Cab.js';
import Punetodapolicab from './pages/Pune to Dapoli Cab.js';
import Punetoguhagartaxi from './pages/Pune to Guhagar Taxi.js';
import Punetovelasbeachcab from './pages/Pune to Velas Beach Cab.js';
import Punetomalvancabservice from './pages/Pune to Malvan Cab Service.js';
import Punedarshancabservice from './pages/Pune Darshan Cab Service.js';
import Punecitytourtaxi from './pages/Pune City Tour Taxi.js';
import Puneonedaytourcab from './pages/Pune One Day Tour Cab.js';
import Puneweeendtourpackage from './pages/Pune Weekend Tour Packages.js';
import Punetoforttourcab from './pages/Pune to Fort Tour Cab.js';
import Puneheritagetourcab from './pages/Pune Heritage Tour Cab.js';
import Ashtavinayakdarshancab from './pages/Ashtavinayak Darshan Cab from Pune.js';
import Punetempletourcab from './pages/Pune Temple Tour Cab.js';
import Punepilgrimagetaxiservice from './pages/Pune Pilgrimage Taxi Service.js';
import Puneereligiontourpackagecab from './pages/Pune Religious Tour Package Cab.js';
import Puneairportcabservice from './pages/Pune Airport Cab Service.js';
import Punetoshirdiairportcab from './pages/Pune to Shirdi Airport Cab.js';
import Puneonewaytaxiservice from './pages/Pune One Way Taxi Service.js';
import Puneroundtripcabservice from './pages/Pune Round Trip Cab Service.js';
import Punetoparbhanicab from './pages/Pune to Parbhani Cab Service.js';
import Punetoaurangabadcabservice from './pages/Pune to Aurangabad Cab Service.js';
import Punetoshaniwarwadatourcab from './pages/Pune to Shaniwar Wada Tour Cab.js';
import Punetobijapurcabservice from './pages/Pune to Bijapur Cab Service.js';
import Punetobelgaumcab from './pages/Pune to Belgaum Cab Service.js';
import Punetochipluntaxi from './pages/Pune to Chiplun Taxi.js';
import Punetomahadcabservice from './pages/Pune to Mahad Cab Service.js';
import Punetomangaoncab from './pages/Pune to Mangaon Cab.js';
import Punetopencabservice from './pages/Pune to Pen Cab Service.js';
import Punetorohataxiservice from './pages/Pune to Roha Taxi Service.js';
import Punetokashidbeachcab from './pages/Pune to Kashid Beach Cab.js';
import Punetomurudjanjiracab from './pages/Pune to Murud Janjira Cab.js';
import Punetoshrivarshantaxiservice from './pages/Pune to Shrivardhan Taxi Service.js';
import Punetowaicabservice from './pages/Pune to Wai Cab Service.js';
import Punetoaundhnagnathcab from './pages/Pune to Aundha Nagnath Cab.js';
import Tempotravelleronrentinpune from './pages/Tempo Traveller on rent in pune.js';
import Urbaniaonrentinpune from './pages/Urbania on rent in Pune.js';
import Innovacrystaonrentinpune from './pages/Innova crysta On rent in pune.js';
import Swiftdzireonrentinpune from './pages/Swift Dzire on rent in pune.js';
import Ertigaonrentinpune from './pages/Ertiga on rent in pune.js';
import Sevanseateronrentinpune from './pages/7 Seater on rent in Pune.js';
import Innovaonrentinpune from './pages/Innova on rent in Pune.js';
import Onethreeonrentinpune from './pages/13 Seater on rent in Pune.js';
import Onesevantempotravelleronrent from './pages/17 Seater Tempo Traveller on rent in Pune.js';
import OurFleets from './pages/OurFleets.js.js';
import ContactButtons from './components/ContactButtons.js';
import Punetobanglorecab from './pages/Pune to Bangalore Cab.js';
import Punetoayodhyatour from './pages/Pune to Ayodhya Tour Package.js';
import Oneseaterurbaniaonrentinpune from './pages/17 Seater Urbania on Rent in Pune.js';
import Urbaniahireforpicnicinpune from './pages/Urbania Hire for Picnic in Pune.js';
import Urbaniaonrentforoutstationpune from './pages/Urbania On Rent for Outstation Pune.js';
import Punetomumbaiurbaniaonrent from './pages/Pune to Mumbai Urbania On Rent.js';
import Luxuryforceurbaniaonrentinpune from './pages/Luxury Force Urbania on Rent in Pune.js';
import Urbaniahireinpune from './pages/Urbania Hire in Pune.js';
import Onethreeseaterurbaniaonrentinpune from './pages/13 Seater Urbania on Rent in Pune.js';
import Acurbaniaonrentinpune from './pages/AC Urbania on Rent in Pune.js';
import Urbaniaperkmmrateinpune from './pages/Urbania per km rate in Pune.js';
import Luxurytempotraveleronrentinpune from './pages/Luxury Tempo Traveller On Rent in Pune.js';
import Onethreetempotravelleronrent from './pages/13 Tempo Traveller On Rent in Pune.js';
import Punetomahabaleshwartempotraveller from './pages/Pune to Mahabaleshwar Tempo Traveller on Rent.js';

function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/services" element={<Service />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/career" element={<CareerSection />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-fleet" element={<OurFleets />} />
        <Route path="/our-network" element={<OurNetwork />} />
   



<Route path="/Pune-Outstation-Cab-Service" element={<Punetooutstationcabservice />} />
<Route path="/Pune-Taxi-Service" element={<Punetaxiservice />} />
<Route path="/Pune-Cab-Booking" element={<Punecabbooking />} />
<Route path="/Best-Cab-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Outstation-Taxi-Service-Pune" element={<Outstationtaxiservicepune />} />
<Route path="/Cheap-Cabs-in-Pune" element={<Cheapcabinpune />} />
<Route path="/Pune-Cab-Fare" element={<Punecabfare />} />
<Route path="/Corporate-Cab-Service-Pune" element={<Corporatecabservicepune />} />
<Route path="/Pune-Airport-Cab" element={<Puneairportcab />} />
<Route path="/Pune-Railway-Station-Cab-Service" element={<Punerailwaystationcabservice />} />
<Route path="/Pune-One-Way-Cab-Service" element={<Puneonewaycabservice />} />
<Route path="/Pune-Local-and-Outstation-Cab" element={<Punelocalandouutstationcab />} />

<Route path="/Pune-to-Mumbai-Cab" element={<Punetomumbaicab />} />
<Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Pune-to-Nashik-Cab-Service" element={<Punetonashikcabservice />} />
<Route path="/Pune-to-Nagpur-Cab" element={<Punetonagpurcab />} />
<Route path="/Pune-to-Kolhapur-Cab" element={<Punetokolhapurcab />} />
<Route path="/Pune-to-Solapur-Cab-Service" element={<Punetosolapurcabservice />} />
<Route path="/Pune-to-Ahmednagar-Taxi" element={<Punetoahmednagartaxi />} />
<Route path="/Pune-to-Sangli-Cab" element={<Punetosanglicab />} />
<Route path="/Pune-to-Satara-Cab-Service" element={<Punetosataracabservice />} />
<Route path="/Pune-to-Jalgaon-Cab-Service" element={<Punetojalgaoncabservice />} />
<Route path="/Pune-to-Thane-Cab" element={<Punetothanecab />} />
<Route path="/Pune-to-Panvel-Cab" element={<Punetopanvelcab />} />
<Route path="/Pune-to-Hyderabad-Cab" element={<Punetohyderabadcab />} />
<Route path="/Pune-to-Goa-Cab-Service" element={<Punetogoacabservice />} />
<Route path="/Pune-to-Sambhaji-Nagar-Cab" element={<Punetosambhajinagar />} />
<Route path="/Pune-to-Nanded-Cab-Service" element={<Punetonandedcabservice />} />
<Route path="/Pune-to-Indore-Cab" element={<Punetoindorecab />} />
<Route path="/Pune-to-Surat-Cab" element={<Punetosuratcab />} />
{/* <Route path="/Pune-to-Vapi-Cab-Service" element={<PuneToVapiCabService />} /> */}
<Route path="/Pune-to-Ujjain-Cab-Service" element={<Punetoujjaincabservice />} />
{/* <Route path="/Pune-to-Kalyan-Cab" element={<PuneToKalyanCab />} /> */}
{/* <Route path="/Pune-to-Dombivli-Cab" element={<PuneToDombivliCab />} /> */}

<Route path="/Pune-to-Lonavala-Cab" element={<Punetolonavalacab />} />
{/* <Route path="/Pune-to-Khandala-Cab" element={<PuneToKhandalaCab />} /> */}
<Route path="/Pune-to-Matheran-Taxi-Service" element={<Punetomatherantaxiservice />} />
<Route path="/Pune-to-Mahabaleshwar-Taxi" element={<Punetomahabaleshwartaxi />} />
{/* <Route path="/Pune-to-Panchgani-Cab-Service" element={<Punetopanchganicab />} /> */}
{/* <Route path="/Pune-to-Lavasa-Cab-Service" element={<PuneToLavasaCabService />} /> */}
<Route path="/Pune-to-Igatpuri-Taxi" element={<Punetolgatpuritaxi />} />
<Route path="/Pune-to-Bhandardara-Cab" element={<Punetobhandardaracab />} />
<Route path="/Pune-to-Karjat-Cab" element={<Punetokarjatcab />} />
<Route path="/Pune-to-Amboli-Ghat-Taxi" element={<Punetoambolighattaxi />} />
<Route path="/Pune-to-Chikhaldara-Cab" element={<Punetochikhaldara />} />
<Route path="/Pune-to-Tamhini-Ghat-Cab" element={<Punetotamhinighatcab />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Pune-to-Trimbakeshwar-Cab-Service" element={<Punetotrimkeshwarcabservice />} />
<Route path="/Pune-to-Bhimashankar-Taxi-Service" element={<Punetobhimashankartaxiservice />} />
<Route path="/Pune-to-Ashtavinayak-Darshan-Cab" element={<Punetoashtavinayakdarshancab />} />
<Route path="/Pune-to-Jejuri-Cab-Service" element={<Punetojejuricab />} />
<Route path="/Pune-to-Pandharpur-Taxi" element={<Punetopandharpurtaxi />} />
<Route path="/Pune-to-Tuljapur-Cab" element={<Punetotuljapurcab />} />
<Route path="/Pune-to-Akkalkot-Cab-Service" element={<Punetoakkalkotcabservice />} />
<Route path="/Pune-to-Shani-Shingnapur-Cab" element={<Punetoshanishingnapurcab />} />
<Route path="/Pune-to-Shegaon-Cab" element={<Punetoshegaoncab />} />
<Route path="/Pune-to-Ganpatipule-Taxi" element={<Punetoganpatipuletaxi />} />
<Route path="/Pune-to-Konkan-Darshan-Cab" element={<Punetokonkandarshancab />} />
<Route path="/Pune-to-Alibag-Cab" element={<Punetoalibaugcab />} />
<Route path="/Pune-to-Ratnagiri-Taxi-Service" element={<Punetoratnagiritaxiservice />} />
<Route path="/Pune-to-Tarkarli-Cab" element={<Punetotarkalicab />} />
<Route path="/Pune-to-Sindhudurg-Cab-Service" element={<Punetosindhudurgcabseervice />} />
<Route path="/Pune-to-Harihareshwar-Taxi" element={<Punetoharihareshwartaxi />} />
<Route path="/Pune-to-Diveagar-Cab" element={<Punetodivegarcab />} />
<Route path="/Pune-to-Dapoli-Cab" element={<Punetodapolicab />} />
<Route path="/Pune-to-Guhagar-Taxi" element={<Punetoguhagartaxi />} />
<Route path="/Pune-to-Velas-Beach-Cab" element={<Punetovelasbeachcab />} />
<Route path="/Pune-to-Malvan-Cab-Service" element={<Punetomalvancabservice />} />
<Route path="/Pune-Darshan-Cab-Service" element={<Punedarshancabservice />} />
<Route path="/Pune-City-Tour-Taxi" element={<Punecitytourtaxi />} />
<Route path="/Pune-One-Day-Tour-Cab" element={<Puneonedaytourcab />} />
<Route path="/Pune-Weekend-Tour-Packages" element={<Puneweeendtourpackage />} />
<Route path="/Pune-to-Fort-Tour-Cab" element={<Punetoforttourcab />} />
<Route path="/Pune-Heritage-Tour-Cab" element={<Puneheritagetourcab />} />
<Route path="/Ashtavinayak-Darshan-Cab-from-Pune" element={<Ashtavinayakdarshancab />} />
<Route path="/Pune-Temple-Tour-Cab" element={<Punetempletourcab />} />
<Route path="/Pune-Pilgrimage-Taxi-Service" element={<Punepilgrimagetaxiservice />} />
<Route path="/Pune-Religious-Tour-Package-Cab" element={<Puneereligiontourpackagecab />} />
<Route path="/Pune-Airport-Cab-Service" element={<Puneairportcabservice />} />
{/* <Route path="/Pune-Railway-Station-Cab-Service" element={<PuneRailwayStationCabService />} /> */}
<Route path="/Pune-to-Shirdi-Airport-Cab" element={<Punetoshirdiairportcab />} />
<Route path="/Pune-One-Way-Taxi-Service" element={<Puneonewaytaxiservice />} />
<Route path="/Pune-Round-Trip-Cab-Service" element={<Puneroundtripcabservice />} />
<Route path="/Pune-to-Parbhani-Cab-Service" element={<Punetoparbhanicab />} />
<Route path="/Pune-to-Aurangabad-Cab-Service" element={<Punetoaurangabadcabservice />} />
<Route path="/Pune-to-Shaniwar-Wada-Tour-Cab" element={<Punetoshaniwarwadatourcab />} />
<Route path="/Pune-to-Bijapur-Cab-Service" element={<Punetobijapurcabservice />} />
<Route path="/Pune-to-Belgaum-Cab-Service" element={<Punetobelgaumcab />} />
<Route path="/Pune-to-Chiplun-Taxi" element={<Punetochipluntaxi />} />
<Route path="/Pune-to-Mahad-Cab-Service" element={<Punetomahadcabservice />} />
<Route path="/Pune-to-Mangaon-Cab" element={<Punetomangaoncab />} />
<Route path="/Pune-to-Pen-Cab-Service" element={<Punetopencabservice />} />
<Route path="/Pune-to-Roha-Taxi-Service" element={<Punetorohataxiservice />} />
<Route path="/Pune-to-Kashid-Beach-Cab" element={<Punetokashidbeachcab />} />
<Route path="/Pune-to-Murud-Janjira-Cab" element={<Punetomurudjanjiracab />} />
<Route path="/Pune-to-Shrivardhan-Taxi-Service" element={<Punetoshrivarshantaxiservice />} />
<Route path="/Pune-to-Wai-Cab-Service" element={<Punetowaicabservice />} />
<Route path="/Pune-to-Aundha-Nagnath-Cab" element={<Punetoaundhnagnathcab />} />
<Route path="/Tempo-Traveller-on-rent-in-pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Urbania-on-rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Innova-crysta-On-rent-in-pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Swift-Dzire-on-rent-in-pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Ertiga-on-rent-in-pune" element={<Ertigaonrentinpune />} />
<Route path="/7-Seater-on-rent-in-Pune" element={<Sevanseateronrentinpune />} />
<Route path="/Innova-on-rent-in-Pune" element={<Innovaonrentinpune />} />
<Route path="/13-Seater-on-rent-in-Pune" element={<Onethreeonrentinpune />} />
<Route path="/17-Seater-Tempo-Traveller-on-rent-in-Pune" element={<Onesevantempotravelleronrent />} />
<Route path="/Pune-to-Bangalore-Cab" element={<Punetobanglorecab />} />

<Route path="/Pune-to-Ayodhya-Tour-Package" element={<Punetoayodhyatour />} />


<Route path="/17-Seater-Urbania-on-Rent-in-Pune" element={<Oneseaterurbaniaonrentinpune />} />
<Route path="/Urbania-Hire-for-Picnic-in-Pune" element={<Urbaniahireforpicnicinpune />} />
<Route path="/Urbania-On-Rent-for-Outstation-Pune" element={<Urbaniaonrentforoutstationpune />} />
<Route path="/Pune-to-Mumbai-Urbania-On-Rent" element={<Punetomumbaiurbaniaonrent />} />
<Route path="/Luxury-Force-Urbania-on-Rent-in-Pune" element={<Luxuryforceurbaniaonrentinpune />} />
<Route path="/Urbania-Hire-in-Pune" element={<Urbaniahireinpune />} />
<Route path="/13-Seater-Urbania-on-Rent-in-Pune" element={<Onethreeseaterurbaniaonrentinpune />} />
<Route path="/AC-Urbania-on-Rent-in-Pune" element={<Acurbaniaonrentinpune />} />
<Route path="/Urbania-per-km-rate-in-Pune" element={<Urbaniaperkmmrateinpune />} />
<Route path="/Luxury-Tempo-Traveller-On-Rent-in-Pune" element={<Luxurytempotraveleronrentinpune />} />
<Route path="/13-Tempo-Traveller-On-Rent-in-Pune" element={<Onethreetempotravelleronrent />} />
<Route path="/Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" element={<Punetomahabaleshwartempotraveller />} />

     </Routes>


<Footer/>
    </Router>
  );
}

export default App;
